<template>
    <div class="temp">
        <dv-scroll-ranking-board
            :config="config"
            style="height: 90%;border-top: 0.125rem solid rgba(1, 153, 209, .5)"
        />
    </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import moment from "moment";

export default {
    name: "ProgramProcessScroll",
    mixins: [EmCommonApi],
    data() {
        return {
            config: {},
            reFresh: {}
        };
    },
    mounted() {
        this.getRemoteData()
        this.reFresh = setInterval(() => {
            this.getRemoteData()
        }, 12 * 3600 * 1000);
    },
    beforeDestroy() {
        clearInterval(this.reFresh)
    },
    methods: {
        getRemoteData() {
            let _this = this;
            let _api = `${this.$_emApiMixin_moduleBaseApi("sithMesPrdProjectInfo")}/sithMesPrdProjectInfo/processRate`
            this.$_emApiMixin_get(_api, false).then(value => {
                let dataList = {
                    data: [],
                    sort: false,
                    unit: "%",
                    rowNum: 8
                };
                console.log(value)
                for (let item of value) {
                    dataList.data.push({
                        name: item.key,
                        value: Math.floor(item.value * 100)
                    })
                }
                _this.config = dataList;
            })
        }
    }
};
</script>

<style scoped>
.temp {
    width: 100%;
    height: 100%;
}

.temp >>> .ranking-info {
    font-size: 1rem;
}

.temp >>> .ranking-info .rank {
    margin-left: 0.5rem;
}

.temp >>> .ranking-info .info-name {
    /*margin-left: 0.6rem;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.temp >>> .ranking-column {
    border-bottom: 0.125rem solid rgba(19, 112, 251, 0.5);
    margin-top: 0.3125rem;
}

.temp >>> .ranking-column .inside-column {
    height: 0.375rem;
    margin-bottom: 0.125rem;
    border-radius: 0.0625rem;
    background-color: #24ae6d;
}

.temp >>> .ranking-column .shine {
    top: 0.125rem;
    height: 0.125rem;
    width: 3.125rem;
}
</style>
